import _ from 'lodash';
import SliderFull from 'src/components/widgets/widget-slider';
import { convertDataListsNonNullCount } from 'src/utils/datasets';
import dynamic from 'next/dynamic';
import { KEY_ADS_POSITION } from 'src/utils/ads/dynamic-ads';
import styled from 'styled-components';

const DynamicAds = dynamic(import('src/utils/ads/dynamic-ads'));
const SectionEventNewspaper = ({ bannerInews = [], eventDataLayer, ads }) => {
  let dataBanner = [];
  if (!_.isEmpty(bannerInews)) {
    dataBanner = bannerInews;
  }

  // const rectangleA = !isEmpty(ads?.find((el) => el.position === 'rectangle-a'));
  const image = _.isEmpty(bannerInews) ? [] : { ...convertDataListsNonNullCount(dataBanner?.dataSet, ['pic-']) };
  const link = _.isEmpty(bannerInews) ? [] : { ...convertDataListsNonNullCount(dataBanner?.dataSet, ['link-']) };
  return (
    <SectionWrapper className='container section-event-6'>
      <div className='row align-items-center'>
        <div className='col-12 col-md-8'>
          <SliderFull
            data={[...Array(4)]}
            heading='ตารางหุ้น'
            type='stock'
            dataSrc='/pdf/stock_daily/S'
            more={`https://image.bangkokbiznews.com/pdf/stock_daily/S01.pdf?date=${Date.now()}`}
            headingDatalayer='ตารางหุ้น'
            //! DATALAYER
            eventDataLayer={{
              ...eventDataLayer,
              data: {
                title: `https://image.bangkokbiznews.com/pdf/stock_daily/S01.pdf?date=${Date.now()}`,
                heading: 'ตารางหุ้น'
              }
            }}
          />
        </div>
        <div className='col-12 col-md-4 flex-center'>
          {!_.isEmpty(dataBanner) && image?.pic?.nonNullCount > 0 ? (
            <div>
              <div className='box-ads'>
                {image?.pic?.values.map(
                  (item, index) =>
                    item && (
                      <a href={link?.link?.values[index]} target='_blank' rel='noopener noreferrer nofollow' key={index}>
                        <img src={item} alt={`Image ${index + 1}`} width='100%' />
                      </a>
                    )
                )}
              </div>
              {image?.pic?.nonNullCount < 2 && <div className=''>{!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.RECTANGLE_A} data={ads} />}</div>}
            </div>
          ) : (
            <div className=''>{!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.RECTANGLE_A} data={ads} />}</div>
          )}
        </div>
      </div>
    </SectionWrapper>
  );
};

export default SectionEventNewspaper;

const SectionWrapper = styled.div`
  .flex-center {
    display: flex;
    justify-content: center;
  }
`;
